'use client';

import { usePathname } from 'next/navigation';
import { SearchAutocomplete } from './SearchAutocomplete';

export const PublicSearchToolbar = () => {
  const pathname = usePathname().replace(/\/$/, '');
  const showSearch = pathname.startsWith('/hub/') || pathname === '/providers' || pathname.startsWith('/providers/');

  if (!showSearch) {
    return null;
  }

  return <section aria-label="Search the logistics directory" className="relative z-30 border-b border-slate-200 bg-white">
    <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
      <div className="hidden md:block"><SearchAutocomplete variant="light" size="compact" /></div>
      <div className="md:hidden"><SearchAutocomplete variant="light" size="compact" /></div>
    </div>
  </section>;
};
